import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Book } from '../models/Book.model';
import { BooksService } from '../services/books.service';

@Component({
  selector: 'app-book-list',
  templateUrl: './book-list.component.html',
  styleUrls: ['./book-list.component.scss']
})
export class BookListComponent implements OnInit, OnDestroy {

  // Ne pas initialiser books, sinon on ne peut pas utiliser undefined pour afficher un message de chargement
  books!: Book[];

  bookSubscription!: Subscription;
  
  constructor(private booksService: BooksService, private router: Router) { }

  ngOnInit(): void {
    this.bookSubscription = this.booksService.booksSubject.subscribe(
      (books: Book[]) => {
        this.books = books;
      }
    );

    this.booksService.getBooks();

    // En enlevant cet emitBooks qui est déjà dans getBooks, je ne sais pas pourquoi mais je n'ai plus le problème d'affichage du message disant qu'il n'y a pas de livre. 
    // Je voulais mettre un effet de chargement, mais ça ça me va aussi.
    
    // this.booksService.emitBooks();
  }

  onNewBook() {
    this.router.navigate(['/books', 'new']);
  }

  onDeleteBook(book: Book) {
    this.booksService.removeBook(book);
  }

  onViewBook(id: number) {
    this.router.navigate(['/books', 'view', id]);
  }

  ngOnDestroy() {
    this.bookSubscription.unsubscribe();
  }

}
